import { Center, Text } from '@chakra-ui/react';

export const NotificationsListPage = () => {
  return (
    <Center height="100%">
      <Text color="whiteAlpha.600">Notifications - Coming Soon</Text>
    </Center>
  );
};
